import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "Never lose a business card again",
  "Follow up while the conversation is still warm",
  "See your networking progress at a glance",
  "Keep work contacts out of your personal phonebook — until you choose to save them",
];

export const Benefits = () => (
  <section id="benefits" className="bg-toto-lavender/50 py-16 sm:py-24" data-testid="benefits-section">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <div>
        <span className="text-xs font-semibold uppercase tracking-widest text-toto-blue" data-testid="benefits-eyebrow">Benefits</span>
        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="benefits-heading">
          Every card you collect becomes an opportunity
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          Most cards end up forgotten in a drawer. TOTO makes sure each one turns into a living connection.
        </p>
        <ul className="mt-8 space-y-4">
          {BENEFITS.map((b) => (
            <li key={b} className="flex items-start gap-3" data-testid={`benefit-item-${b.slice(0, 20).toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-toto-blue" />
              <span className="text-base text-slate-700">{b}</span>
            </li>
          ))}
        </ul>
      </div>
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5 }}
        className="mx-auto w-full max-w-xs"
      >
        <div className="overflow-hidden rounded-[2.5rem] border-[10px] border-slate-900 bg-slate-900 shadow-2xl" data-testid="benefits-phone-mockup">
          <img src="/assets/screens/contact-details.jpeg" alt="TOTO contact details with save to phone" loading="lazy" className="block h-full w-full rounded-[1.9rem] object-cover object-top" />
        </div>
      </motion.div>
    </div>
  </section>
);
